/**
 *
 * @description
 * pick all keys from target and return new object with source
 * @param target
 * @param source
 * @returns Object
 *
 * @example
 *
 * const target = {
 *  a: "",
 *  b: "",
 *  c: ""
 * }
 *
 * const source = {
 *   a: 1,
 *   b: 2,
 *   c: 3,
 *   d: 4,
 *   e: 5
 * }
 *
 * const result = merge(target, source); // { a: 1, b: 2, c: 3 }
 */

export const merge = (
  target: Record<string, unknown>,
  source: Record<string, unknown>
) => {
  const keys = Object.keys(target);

  return keys.reduce(
    (result, key) => ({
      ...result,
      [key]: source[key]
    }),
    {}
  );
};
